const apiId = {
  bodyAd: "pc_background", //背景广告number
  bodyAdId: 850, //网站背景栏目id
  newsId: 210, //资讯id
  homeBannerId: 598, //首页banner id
  recommendNewsId: 211, //推荐新闻 id
  noticeId: 597, //公告 id
  serviceId: 587, //服务id
  villageId: 580, //一村一品id
  foodId: 581, //一村一品美食id
  travelId: 582, //一村一品旅游id
  activityId: 584, //精彩活动id
  shoppingBannerId: 610, // 电商轮播id
  shoppingHotId: 611, // 电商当季热门id
  shoppingRecommendId: 612, // 电商精选推荐id
  shoppingFoodId: 700, // 电商美食购物id
  shoppingTravelId: 701, // 电商旅游出行id
  governmentRulesId: 685, //政策法规id
  countryId: 251, //乡镇id
  officeId: 252, //机关id
  businessId: 253, //企业id
  liveNoticeId: 401, //同城生活-信息公告id
  aboutId: 702, //关于我们 id
  statementId: 730, //网站声明 id
  contactId: 731 //联系我们 id
}

export default apiId



// WEBPACK FOOTER //
// ./src/api/apiId.js